import React from 'react';
import { DashedTitle, Icon, Tabs } from '@fasstech/middle-design-system';
import { equals } from 'ramda';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import { useTabs } from '@@viewCommonComponents/hooks/useTabs.js';
import TabsPagination from '@@viewCommonComponents/TabsPagination.jsx';
import SummaryIndividualHealthCard from './SummaryIndividualHealthCard.jsx';
import { isCustomerModePavillon } from '@@viewCommonComponents/displayer/extra/isCustomerModePavillon.js';
import Beneficiaries from '@@views/souscriptionRecap/client/components/Beneficiaries.jsx';

const SummaryIndividualHeath = ({
  getMiddleText,
  grantees,
  packs,
  effectDate,
  offerCode,
  onEdit,
  viewMode,
  customerCardOptions,
  granteesCardOptions,
  onEditBeneficiaries
}) => {
  const customerModePavillon = isCustomerModePavillon(
    equals(viewMode, 'CUSTOMER')
  );
  const isCustomerMode =
    customerModePavillon === true ? false : equals(viewMode, 'CUSTOMER');

  const {
    tabs,
    setTabs,
    setSelectedGrantee,
    displayTabsPagination,
    updateVisibility,
    isButtonDisabled
  } = useTabs({
    grantees,
    getMiddleText,
    defaultMaxVisibleTabs: 5,
    filteredViewMode: isCustomerMode
  });
  return (
    <>
      <div className="flex flex-col items-center gap-4">
        <Icon name={'circleContract'} size={50} />
        <DashedTitle>
          {getMiddleText('RECAPITULATIF_PRODUCTS_TITLE')}
        </DashedTitle>

        <div className="border border-[#E7E7E7] rounded-md w-full">
          <div
            className={
              'w-full flex justify-between items-center p-4 border-b'
            }
          >
            <TabsPagination
              updateVisibility={updateVisibility}
              isButtonDisabled={isButtonDisabled}
              show={displayTabsPagination}
            >
              <Tabs
                items={tabs.tabs}
                selected={tabs.selectedTab}
                onClick={(index) => {
                  setTabs({
                    selectedTab: index,
                    tabs: tabs.tabs
                  });
                  const grantee = grantees[index];
                  if (grantee) {
                    setSelectedGrantee(grantee);
                  }
                }}
              />
            </TabsPagination>
            <Icon
              name={'circlePen'}
              size={30}
              className={'cursor-pointer'}
              onClick={onEdit}
            />
          </div>
          {mapIndexed((pack, index) => {
            if (index !== tabs.selectedTab) return null;
            return (
              <SummaryIndividualHealthCard
                key={index}
                pack={pack}
                effectDate={effectDate}
                getMiddleText={getMiddleText}
                offerCode={offerCode}
              />
            );
          }, packs)}
        </div>
      </div>
      <Beneficiaries
        getMiddleText={getMiddleText}
        grantees={grantees}
        customerCardOptions={customerCardOptions}
        granteesCardOptions={granteesCardOptions}
        onEdit={onEditBeneficiaries}
      />
    </>
  );
};

export default SummaryIndividualHeath;
